export class GlobalConstants {
    /* OLD API USAGE - Deprecated by Wired Programming Multi-Tenant API
        public static apiURL = 'https://api.eazybreezyhc.com:443/api';
        public static dataServer = 'https://api.eazybreezyhc.com:443';
    */
    public static apiURL = 'https://api.wiredprogramming.com:443/api';
    public static dataServer = 'https://api.wiredprogramming.com:443';
    public static apiKey = 'densecamel29lightmonth89trickysnake19';
};